const settings = {
  language: "Language",
  hebrew: "Hebrew",
  english: "English",
  russian: "Russian",
  sidebarPosition: "Sidebar position",
  right: "Right",
  left: "Left",
  sidebarVisibility: "Sidebar visibility",
  visible: "Visible",
  float: "Float",
  hidden: "Hidden",
  themeMode: "Theme",
  themeModeDark: "Dark",
  themeModeLight: "Light",
  theme: "Theme",
  accentColor: "Accent Color",
  fontFamily: "Font",
  borderRadius: "Corners",
  density: "Density",
  textSize: "Text size",
  textNormal: "Normal",
  textLarge: "Large",
  textXLarge: "Extra large",
  sharp: "Sharp",
  default: "Default",
  round: "Round",
  compact: "Compact",
  spacious: "Spacious",
  heebo: "Heebo",
  geist: "Geist",
  inter: "Inter",
  system: "System",
  openSettings: "Open Settings",
  tabGeneral: "General",
  tabTheme: "Theme",
  tabBrand: "Brand",
  tabWidgetBar: "Widget Bar",
  activeProfile: "Active Profile",
  noActiveProfile: "No profile selected",
  profileModified: "(modified)",
  saveNewProfile: "Save current as new profile",
  profileNamePlaceholder: "Profile name...",
  savedProfiles: "Saved Profiles",
  noProfiles: "No saved profiles yet",
  loadProfile: "Load",
  renameProfile: "Rename",
  overwriteProfile: "Update Profile",
  updateProfile: "Update Existing Profile",
  builtIn: "Built-in",
  profileDefault: "Default",
  profileMinimal: "Minimal",
  profileLoaded: "Profile loaded",
  profileSaved: "Profile saved",
  profileDeleted: "Profile deleted",
  colorPicker: "Color Picker",
  myPalette: "My Palette",
  noSavedColors: "No saved colors yet",
  colorCombos: "Color Combos",
  effects: "Effects",
  gradient: "Gradient",
  gradientDirection: "Direction",
  secondaryColor: "Secondary Color",
  glow: "Glow",
  glowIntensity: "Intensity",
  subtle: "Subtle",
  medium: "Medium",
  strong: "Strong",
  useAsAccent: "Use as Accent",
  saveToPalette: "Save to Palette",
  custom: "Custom",
  on: "On",
  off: "Off",
  comboSunset: "Sunset",
  comboOcean: "Ocean",
  comboAurora: "Aurora",
  comboForest: "Forest",
  comboFlame: "Flame",
  comboRoyal: "Royal",
  comboMidnight: "Midnight",
  comboRoseGold: "Rose Gold",
  comboGlacier: "Glacier",
  lockColor: "Lock Color",
  unlockColor: "Unlock Color",
  useAsBrand: "Use as Brand Color",
  removeColor: "Remove Color",
  colorArchive: "Color Archive",
  noArchivedColors: "No archived colors",
  restoreColor: "Restore",
  deletePermanently: "Delete Permanently",
  navColor: "Navigation Color",
  navColorHint: "Background color for sidebar and top bar",
  resetNavColor: "Reset (follow theme)",
  colorTheme: "Color Theme",
  darkThemes: "Dark",
  lightThemes: "Light",
  tabPwa: "PWA",
  gibberishDetect: "Wrong keyboard detection",
  gibberishDetectHint: "Auto-detect when typing in the wrong language",
  gibberishMeantHebrew: "Did you mean Hebrew?",
  gibberishMeantEnglish: "Did you mean English?",
  gibberishConvert: "Convert",
  tabAccounts: "Integrations",
  tabEmailTemplates: "Email Templates",
  tabProfile: "Profile",
  tabSearch: "Search",
  tabSystem: "System",
  tabUsers: "Users",
  tabLogin: "Login",
  tabShortcuts: "Shortcuts",
  connectedAccounts: "Connected Accounts",
  connectGoogle: "Connect Google Account",
  googleSection: "Google",
  scopeGmail: "Gmail",
  scopeCalendar: "Calendar",
  disconnect: "Disconnect",
  disconnectConfirm: "Are you sure you want to disconnect this account?",
  accountConnected: "Account connected successfully",
  accountDisconnected: "Account disconnected",
  active: "Active",
  inactive: "Inactive",
  noAccounts: "No connected accounts",
  noAccountsHint: "Connect a Google account to access Gmail and Calendar",
  integrationsTitle: "Integrations Hub",
  sectionAuthSecurity: "Auth & Security",
  sectionCommunication: "Communication Services",
  sectionExternalServices: "External Services",
  sectionMessaging: "Messaging Credits",
  currentLoginMethod: "Current login method",
  connectedProviders: "Connected identity providers",
  linkProvider: "Link",
  unlinkProvider: "Unlink",
  noProviders: "No providers connected",
  otpEnabled: "OTP enabled",
  otpDisabled: "OTP disabled",
  webhookUrl: "Webhook URL",
  copied: "Copied!",
  copyUrl: "Copy",
  configured: "Configured",
  notConfigured: "Not configured",
  connected: "Connected",
  comingSoon: "Coming soon",
  testConnection: "Test connection",
  connectionOk: "Connection OK",
  connectionFailed: "Connection failed",
  watiWhatsapp: "WATI — WhatsApp",
  voicenterPbx: "Voicenter — PBX",
  origamiCrm: "Origami CRM",
  notionIntegration: "Notion",
  n8nAutomation: "n8n — Automations",
  zapierIntegration: "Zapier",
  makeIntegration: "Make",
  smsCredits: "SMS (Twilio)",
  emailCredits: "Email (Resend)",
  providerEmail: "Email + Password",
  providerOtp: "One-time code",
  providerGithub: "GitHub",
  providerFacebook: "Facebook",
  providerMicrosoft: "Microsoft",
  providerApple: "Apple",
  providerLinkedin: "LinkedIn",
  providerGoogle: "Google",
  tabSkins: "Skins",
  skinsTitle: "Skins — Display Style",
  skinsSubtitle: "Choose a style for each layer independently",
  skinShellTitle: "Shell (Frame)",
  skinShellDesc: "Sidebar, topbar, navigation — the outer frame of the app",
  skinContentTitle: "Content (Pages)",
  skinContentDesc: "Cards, tables, forms — inner page design",
  skinMobileNavTitle: "Mobile Navigation",
  skinMobileNavDesc: "Navigation style on small screens — bottom bar, hamburger and more",
  skinCurrent: "Current",
  skinFeatures: "Features",
  skinSafetyNote: "Safety",
} as const;
export default settings;
